import { useEffect, useState } from "react";
import { useLang } from "../lib/i18n";
import { useCart } from "../lib/CartContext";

const WHATSAPP_INTL = "201042192135";

function isOpenNow() {
  const weekday = new Intl.DateTimeFormat("en-US", { timeZone: "Africa/Cairo", weekday: "long" }).format(new Date());
  return weekday !== "Friday"; // Sat-Thu open 24/7, Friday closed
}

export default function WhatsAppWidget() {
  const { t } = useLang();
  const { checkoutOpen } = useCart();
  const [online, setOnline] = useState(isOpenNow());

  useEffect(() => {
    const id = setInterval(() => setOnline(isOpenNow()), 60000);
    return () => clearInterval(id);
  }, []);

  if (checkoutOpen) return null;

  const wa = `https://wa.me/${WHATSAPP_INTL}`;

  return (
    <a
      href={wa}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-widget-btn"
      aria-label="Chat with Pet Munchies on WhatsApp"
      className="fixed bottom-5 right-5 z-50 group"
    >
      <span
        className="absolute inset-0 rounded-full animate-ping"
        style={{ background: "#25D366", opacity: 0.35 }}
      />
      <span
        className="relative flex items-center justify-center w-14 h-14 rounded-full transition-transform duration-300 ease-out group-hover:scale-110 group-active:scale-95"
        style={{ background: "#25D366", border: "2px solid #0F172A", boxShadow: "4px 4px 0 0 #0F172A" }}
      >
        <svg viewBox="0 0 24 24" width="28" height="28" fill="white" aria-hidden="true">
          <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21h.01c5.46 0 9.9-4.45 9.9-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0012.04 2zm5.71 14.02c-.24.68-1.42 1.32-1.96 1.4-.5.08-1.13.11-1.83-.12-.42-.14-.96-.32-1.65-.63-2.9-1.25-4.79-4.17-4.93-4.36-.14-.19-1.18-1.57-1.18-3 0-1.42.75-2.12 1.02-2.41.27-.29.58-.36.78-.36.19 0 .39.002.56.01.18.008.42-.07.66.5.24.58.82 2 .89 2.15.07.15.12.33.02.53-.1.19-.15.31-.29.48-.14.17-.3.38-.43.51-.14.14-.29.29-.12.58.17.29.75 1.24 1.62 2.01 1.11.99 2.05 1.3 2.34 1.44.29.14.46.12.63-.07.18-.19.75-.87.95-1.17.2-.29.4-.24.66-.14.27.1 1.68.79 1.97.93.29.14.48.21.55.34.07.12.07.68-.17 1.36z" />
        </svg>
        <span
          data-testid="whatsapp-status-dot"
          className="absolute -top-0.5 -right-0.5 w-3.5 h-3.5 rounded-full"
          style={{
            background: online ? "#22C55E" : "#94A3B8",
            border: "2px solid #0F172A",
          }}
        />
      </span>
      <span
        className="absolute right-full top-1/2 -translate-y-1/2 mr-3 whitespace-nowrap px-3 py-1.5 rounded-lg bg-slate-900 text-white text-xs font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none hidden sm:block"
        data-testid="whatsapp-widget-tooltip"
      >
        {online ? t("whatsapp.online_now") : t("whatsapp.closed_today")}
      </span>
    </a>
  );
}
